import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAdminRole } from 'api/admin.service';
import { clearPermissionStore } from 'store/permission.store';
import { AxiosError } from 'axios';
import { UserRole } from 'models/user.model';
import { useToast } from 'hooks/ui';

export const useUpdateAdminQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id, role }: { id: string; role: UserRole }) => updateAdminRole(id, role),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['admins']);
        clearPermissionStore();
        toast.success('Admin role updated successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
